// AB TEST POPUP


let addedUpsell = [];

function preventCartOpening() {
  const cart = document.querySelector('#mini-cart');
  if (!cart) return;
  
  cart.style.display = 'none';

  setTimeout(() => {
    const closeBtn = cart.querySelector('.drawer__close-button');
    if (closeBtn) {
      closeBtn.click();
    }

    setTimeout(() => {
      cart.style.removeProperty('display');
    }, 250);
  }, 2000);

  // Also prevent cart:refresh from opening cart for a short period
  const preventHandler = (event) => {
    if (event.detail && event.detail.openMiniCart) {
      event.detail.openMiniCart = false;
    }
  };
  
  document.documentElement.addEventListener('cart:refresh', preventHandler, true);
  
  // Remove the handler after 3 seconds (enough time for recommendations to load)
  setTimeout(() => {
    document.documentElement.removeEventListener('cart:refresh', preventHandler, true);
  }, 3000);
}

function addPopup() {
  const pdpTitle = document.querySelector('.product-meta__title');
  const pdpImg = document.querySelector('.flickity-slider .product__media-item:first-child .product__media-image-wrapper > img');

  const popupHTML = `
    <div class="ve-0014-overlay"></div>
    <div class="ve-0014">
      <div class="ve-0014-header">
        <h1>PRODUKT HINZUGEFÜGT</h1>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.28 0.719971L0.719971 11.28M0.719971 0.719971L11.28 11.28" stroke="#121923" stroke-width="1.5"/>
        </svg>
      </div>
      <div class="ve-0014-content">
        <div class="ve-0014-content-banner">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="8" fill="#F1F7ED"/>
            <path d="M17.12 19.6464L19.2718 21.9201L23.36 17.6001M27.68 20.0001C27.68 24.2416 24.2416 27.6801 20 27.6801C15.7585 27.6801 12.32 24.2416 12.32 20.0001C12.32 15.7585 15.7585 12.3201 20 12.3201C24.2416 12.3201 27.68 15.7585 27.68 20.0001Z" stroke="#8EBF88" stroke-width="1.5"/>
          </svg>
          <p>Dieser Artikel wurde deinem Warenkorb hinzugefügt.</p>
        </div>
        <div class="ve-0014-product">
          <img src="${pdpImg.src}">
          <h3>${pdpTitle.innerHTML}</h3>
          <p class="ve-0014-product-price"></p>
          <div class="ve-0014-product-qt">
            <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 1H12" stroke="#0D0D0D" stroke-width="1.5"/>
            </svg>
            <span></span>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 0V12M0 6H12" stroke="#0D0D0D" stroke-width="1.5"/>
            </svg>
          </div>
          <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.800049 4.23999H15.2M5.60005 4.23999V2.31999C5.60005 1.7898 6.02984 1.35999 6.56005 1.35999H9.44005C9.97026 1.35999 10.4 1.7898 10.4 2.31999V4.23999M8.00005 6.63999V14.32M10.88 6.63999L10.4 14.32M5.12005 6.63999L5.60005 14.32M13.76 4.23999L12.8682 15.8336C12.8297 16.3338 12.4127 16.72 11.9111 16.72H4.08904C3.5874 16.72 3.17034 16.3338 3.13187 15.8336L2.24005 4.23999H13.76Z" stroke="#0D0D0D" stroke-width="1.5"/>
          </svg>
        </div>
        <div class="ve-0014-upsell">
          <h2>Das könnte dir auch gefallen:</h2>
          <div class="ve-0014-upsell-list">
          </div>
        </div>
      </div>
      <div class="ve-0014-footer">
        <div class="ve-0014-footer-close">
          WEITER EINKAUFEN
        </div>
        <div class="ve-0014-footer-cart">
          ZUM WARENKORB
        </div>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', popupHTML);
}

function setupPopup() {
  const popup = document.querySelector('.ve-0014');
  const closeBtns = document.querySelectorAll('.ve-0014-footer-close, .ve-0014-header svg, .ve-0014-overlay');
  closeBtns.forEach((b) => {
    b.addEventListener('click', () => {
      closePopup();
    });
  });

  // Prevent cart from opening when popup is open
  // Intercept cart:refresh events and prevent openMiniCart when popup is visible
  const preventCartOpenHandler = (event) => {
    if (popup && popup.classList.contains('ve-0014-open')) {
      if (event.detail && event.detail.openMiniCart) {
        event.detail.openMiniCart = false;
      }
    }
  };
  document.documentElement.addEventListener('cart:refresh', preventCartOpenHandler, true);

  const cartBtn = popup.querySelector('.ve-0014-footer-cart');
  cartBtn.addEventListener('click', () => {
    const cartOpenBtn =  document.querySelector('.header__icon-wrapper[href*="/cart"]');
    closePopup();
    cartOpenBtn.click();
  });

  const qtMinus = document.querySelector('.ve-0014-product-qt svg:first-child');
  const qtPlus = document.querySelector('.ve-0014-product-qt svg:last-child');
  const removeBtn = document.querySelector('.ve-0014-product > svg');
  let btnTimeout = false;

  const removeProduct = () => {
    const cartProduct = getProductInCart();
    const cartRemove = cartProduct.querySelector('.line-item__remove-button');
    cartRemove.click();
    closePopup();
  };

  removeBtn.addEventListener('click', () => {
    if (btnTimeout === true) {
      return;
    }

    removeProduct();

    btnTimeout = true;
    setTimeout(() => {
      btnTimeout = false;
    }, 1000);
  });

  qtMinus.addEventListener('click', () => {
    if (btnTimeout === true) {
      return;
    }

    const productQt = popup.querySelector('.ve-0014-product-qt span');
    const qt = parseInt(productQt.innerHTML);

    const cartProduct = getProductInCart();
    const btnMinus = cartProduct.querySelector('.quantity-selector__button[aria-label="Menge verringern"]');

    if (qt > 1) {
      productQt.innerHTML = qt - 1;
      btnMinus.click();
    } else {
      removeProduct();
    }

    btnTimeout = true;
    setTimeout(() => {
      btnTimeout = false;
    }, 1000);
  });

  qtPlus.addEventListener('click', () => {
    if (btnTimeout === true) {
      return;
    }

    const productQt = popup.querySelector('.ve-0014-product-qt span');
    const qt = parseInt(productQt.innerHTML);

    const cartProduct = getProductInCart();
    const btnPlus = cartProduct.querySelector('.quantity-selector__button[aria-label="Menge erhöhen"]');

    productQt.innerHTML = qt + 1;
    btnPlus.click();

    btnTimeout = true;
    setTimeout(() => {
      btnTimeout = false;
    }, 1000);
  });
}

function getProductInCart() {
  const id = document.querySelector('.product-form__buy-buttons form input[name="id"]');
  const isAbo = document.querySelector('.subscription-radio.rc-radio--active') !== null;

  if (isAbo) {
    const timeSelector = document.querySelector('.rc-selling-plans-dropdown__select');
    const text = timeSelector.querySelector(`option[value="${timeSelector.value}`).innerHTML;

    const cartItems = document.querySelectorAll(`.line-item[data-vid="${id.value}"]:has(.product-item-meta__property)`);
    for (item of cartItems) {
      const textField = item.querySelector('.product-item-meta__property');

      if (textField.innerHTML.trim() === text.trim()) {
        return item;
      }
    }
  } else {
    return document.querySelector(`.line-item[data-vid="${id.value}"]:not(:has(.product-item-meta__property))`);
  }
}

async function loadUpsell() {
  const upsellPopup = document.querySelector('.ve-0014-upsell-list');
  upsellPopup.innerHTML = '';

  // First, render already added upsell products
  addedUpsell.forEach((u) => {
    const upsellHTML = `
      <div>
        <img src="${u.img}">
        <h3>${u.title}</h3>
        <p>${u.price}</p>
        <div class="ve-0014-upsell-delete">
          <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.800049 4.23999H15.2M5.60005 4.23999V2.31999C5.60005 1.7898 6.02984 1.35999 6.56005 1.35999H9.44005C9.97026 1.35999 10.4 1.7898 10.4 2.31999V4.23999M8.00005 6.63999V14.32M10.88 6.63999L10.4 14.32M5.12005 6.63999L5.60005 14.32M13.76 4.23999L12.8682 15.8336C12.8297 16.3338 12.4127 16.72 11.9111 16.72H4.08904C3.5874 16.72 3.17034 16.3338 3.13187 15.8336L2.24005 4.23999H13.76Z" stroke="#000000" stroke-width="1.5"/>
          </svg>
        </div>
        <div>
          <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="iconify iconify--twemoji" fill="#fff" stroke="#fff">
            <path d="M34.5 1.4a3 3 0 0 0-4.2.9L13.5 28.2l-8.2-7.6a3 3 0 1 0-4 4.4L12 35l.4.3a3 3 0 0 0 4.2-.9L35.3 5.5a3 3 0 0 0-.8-4.1z"/>
          </svg>
        </div>
      </div>
    `;

    upsellPopup.insertAdjacentHTML('beforeend', upsellHTML);

    const btn = upsellPopup.querySelector('div:last-child > div.ve-0014-upsell-delete');
    btn.addEventListener('click', () => {
      const elemInCart = document.querySelector(`.line-item[data-vid="${u.id}"]:not(:has(.product-item-meta__property))`);

      if (elemInCart !== null) {
        const cartRemove = elemInCart.querySelector('.line-item__remove-button');
        cartRemove.click();
      }

      setTimeout(loadUpsell, 2000);

      addedUpsell.splice(addedUpsell.indexOf(u), 1);
    });
  });

  // Get product ID for recommendations API
  try {
    // Try to get product ID from data-productid attribute on product form
    const productForm = document.querySelector('.product-form[data-productid]');
    let productId = null;
    
    if (productForm) {
      productId = productForm.getAttribute('data-productid');
    } else {
      // Fallback: get product ID from variant
      const variantIdInput = document.querySelector('.product-form__buy-buttons form input[name="id"]');
      if (!variantIdInput) {
        console.warn('Could not find product ID or variant ID input');
        return;
      }

      const variantId = variantIdInput.value;
      
      // Fetch variant to get product_id
      const variantResponse = await fetch(`/variants/${variantId}.js`);
      if (!variantResponse.ok) {
        console.warn('Could not fetch variant data');
        return;
      }
      
      const variant = await variantResponse.json();
      productId = variant.product_id;
    }
    
    if (!productId) {
      console.warn('Could not determine product ID');
      return;
    }

    // Fetch recommendations from API
    // Use locale-aware URL if available, otherwise use root
    const rootPath = window.Shopify?.routes?.root || '/';
    const recommendationsUrl = `${rootPath}recommendations/products.json?product_id=${productId}&intent=related&limit=10`;
    console.log(recommendationsUrl);
    const recommendationsResponse = await fetch(recommendationsUrl);
    
    if (!recommendationsResponse.ok) {
      console.warn('Could not fetch product recommendations');
      return;
    }

    const recommendationsData = await recommendationsResponse.json();
    const recommendedProducts = recommendationsData.products || [];

    // Filter out products that are already in addedUpsell and products with "Gratis" in title
    const availableProducts = recommendedProducts.filter(product => {
      const firstVariantId = product.variants?.[0]?.id?.toString();
      const isAlreadyAdded = addedUpsell.find(u => u.id === firstVariantId);
      const hasGratisInTitle = product.title && product.title.toLowerCase().includes('gratis');
      return !isAlreadyAdded && !hasGratisInTitle;
    });

    // Render recommended products
    availableProducts.forEach((product) => {
      const firstVariant = product.variants?.[0];
      if (!firstVariant || !firstVariant.available) {
        return;
      }

      const variantId = firstVariant.id.toString();
      const productImage = product.featured_image || (firstVariant.featured_image || '');
      const productTitle = product.title;
      
      // Format price using formatMoney if available, otherwise use simple formatting
      let formattedPrice = '';
      if (typeof formatMoney === 'function') {
        formattedPrice = formatMoney(firstVariant.price);
      } else {
        // Fallback price formatting
        const priceInEuros = (firstVariant.price / 100).toFixed(2);
        formattedPrice = `${priceInEuros.replace('.', ',')} €`;
      }

      const upsellHTML = `
        <div>
          <img src="${productImage}">
          <h3>${productTitle}</h3>
          <p>${formattedPrice}</p>
          <div>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.99999 0.800049V15.2M0.799988 8.00005H15.2" stroke="white" stroke-width="2"/>
            </svg>
          </div>
        </div>
      `;

      upsellPopup.insertAdjacentHTML('beforeend', upsellHTML);

      const btn = upsellPopup.querySelector('div:last-child > div:has(> svg)');
      btn.addEventListener('click', async () => {
        // Add product to cart
        try {
          const formData = {
            items: [{
              id: variantId,
              quantity: 1
            }]
          };

          const addToCartResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
          });

          if (!addToCartResponse.ok) {
            const errorData = await addToCartResponse.json();
            throw new Error(errorData.description || 'Failed to add product to cart');
          }

          // Dispatch cart:updated event (but don't open cart)
          const cartResponse = await fetch('/cart.js');
          const cartContent = await cartResponse.json();
          
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { cart: cartContent }
            })
          );

          // Dispatch cart:refresh but explicitly prevent cart from opening
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: {
                cart: cartContent,
                openMiniCart: false
              }
            })
          );

          // Add to addedUpsell array
          addedUpsell.push({ 
            img: productImage, 
            title: productTitle, 
            price: formattedPrice, 
            id: variantId 
          });

          // Reload upsell list
          setTimeout(loadUpsell, 500);
        } catch (error) {
          console.error('Error adding product to cart:', error);
          alert('Fehler beim Hinzufügen zum Warenkorb. Bitte versuchen Sie es erneut.');
        }
      });
    });
  } catch (error) {
    console.error('Error loading upsell recommendations:', error);
  }
}

function openPopup() {
  const popup = document.querySelector('.ve-0014');
  const productPrice = popup.querySelector('.ve-0014-product-price');
  const productQt = popup.querySelector('.ve-0014-product-qt span');

  addedUpsell = [];

  const isAbo = document.querySelector('.subscription-radio.rc-radio--active') !== null;
  let pdpPrice = undefined;
  if (isAbo) {
    pdpPrice = document.querySelector('.price-wrap-outer .custom-price-2-wrap .price.price--large');
  } else {
    pdpPrice = document.querySelector('.price-wrap-outer .product-meta__price-list-container .price.price--large');
  }

  productPrice.innerHTML = pdpPrice.innerHTML.replace(/<span.*<\/span>/, '');

  const cartProduct = getProductInCart();
  let cartQt = { value: '0' };
  if (cartProduct !== null && cartProduct !== undefined) {
    cartQt = cartProduct.querySelector('.quantity-selector__input');
  }

  const pdpQt = document.querySelector('.product-form__quantity .quantity-selector__input');
  productQt.innerHTML = parseInt(cartQt.value) + parseInt(pdpQt.value);

  const upsellPopup = document.querySelector('.ve-0014-upsell-list');
  upsellPopup.innerHTML = '';

  setTimeout(() => {
    loadUpsell();
  }, 1000);

  popup.classList.add('ve-0014-open');
}

function closePopup() {
  const popup = document.querySelector('.ve-0014');
  popup.classList.remove('ve-0014-open');
}

document.addEventListener("DOMContentLoaded", () => {
  document.body.classList.add('as-ve-0014');

  const pos = window.scrollY;
  window.scrollTo(0, 0);
  setTimeout(() => {
    window.scrollTo(0, pos);
  }, 50);
});


domReady(() => {
  document.body.classList.add('as-ve-0014');

  const pos = window.scrollY;
  window.scrollTo(0, 0);
  setTimeout(() => {
    window.scrollTo(0, pos);
  }, 50);
});

// Replace ablyftTools.waitForElement for product image
waitForElement('.flickity-slider .product__media-item:first-child .product__media-image-wrapper > img', () => {
  addPopup();
  setupPopup();
});

// Replace ablyftTools.waitForElement for ATC buttons
waitForElement('#AddToCart', (atc) => {
  console.log("FOUND ATC", atc)
  atc.addEventListener('click', () => {
    console.log("CLICKED")
    preventCartOpening();
    openPopup();
  });
});





// const dataMap = {
//   '/products/vegan-protein-vanille': {
//     '3er': {
//       title: '3x Vanille - Spare 10%',
//       img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-3-dosen-10-prozent-ohne-sticker-bourbon-vanille-min_1000x.jpg?v=1759386824',
//       price: '€80,97',
//       comparePrice: '€89,97',
//       unitPrice: '€26,99 /Stück',
//       badge: '-10%',
//       id: '55830643671417',
//     },
//     '5er': {
//       title: '5x Vanille - Spare 15%',
//       img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-5-dosen-15-prozent-ohne-sticker-bourbon-vanille-min_1000x.jpg?v=1759387172',
//       price: '€127,46',
//       comparePrice: '€149,95',
//       unitPrice: '€25.49 /Stück',
//       badge: '-15%',
//       id: '55830667067769',
//     },
//   },
//   '/products/vegan-protein-zimt': {
//     '3er': {
//       title: '3x Zimt - Spare 10%',
//       img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-3-dosen-10-prozent-ohne-sticker-zimt-min_1000x.jpg?v=1759387053',
//       price: '€80,97',
//       comparePrice: '€89,97',
//       unitPrice: '€26,99 /Stück',
//       badge: '-10%',
//       id: '55830728933753',
//     },
//     '5er': {
//       title: '5x Zimt - Spare 15%',
//       img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-5-dosen-15-prozent-ohne-sticker-zimt-min_1000x.jpg?v=1759387377',
//       price: '€127,46',
//       comparePrice: '€149,95',
//       unitPrice: '€25,49 /Stück',
//       badge: '-15%',
//       id: '55830733586809',
//     },
//   },
//   '/products/vegan-protein-kakao': {
//     '3er': {
//       title: '3x Kakao - Spare 10%',
//       img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-3-dosen-10-prozent-ohne-sticker-kakao-min_1000x.jpg?v=1759386853',
//       price: '€80,97',
//       comparePrice: '€89,97',
//       unitPrice: '€26,99 /Stück',
//       badge: '-10%',
//       id: '55830668542329',
//     },
//     '5er': {
//       title: '5x Kakao - Spare 15%',
//       img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-5-dosen-15-prozent-ohne-sticker-kakao-min_1000x.jpg?v=1759387203',
//       price: '€127,46',
//       comparePrice: '€149,95',
//       unitPrice: '€25,49 /Stück',
//       badge: '-15%',
//       id: '55830670115193',
//     },
//   },
//   '/products/vegan-protein-waldbeere': {
//     '3er': {
//       title: '3x Beere - Spare 10%',
//       img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-3-dosen-10-prozent-ohne-sticker-waldbeere-min_1000x.jpg?v=1759386879',
//       price: '€80,97',
//       comparePrice: '€89,97',
//       unitPrice: '€26,99 /Stück',
//       badge: '-10%',
//       id: '55830673523065',
//     },
//     '5er': {
//       title: '5x Beere - Spare 15%',
//       img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-5-dosen-15-prozent-ohne-sticker-waldbeere-min_1000x.jpg?v=1759387228',
//       price: '€127,46',
//       comparePrice: '€149,95',
//       unitPrice: '€25,49 /Stück',
//       badge: '-15%',
//       id: '55830676341113',
//     },
//   },
//   '/products/vegan-protein-banane': {
//     '3er': {
//       title: '3x Banane - Spare 10%',
//       img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-3-dosen-10-prozent-ohne-sticker-banane-min_1000x.jpg?v=1759386995',
//       price: '€80,97',
//       comparePrice: '€89,97',
//       unitPrice: '€26,99 /Stück',
//       badge: '-10%',
//       id: '55830715203961',
//     },
//     '5er': {
//       title: '5x Banane - Spare 15%',
//       img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-5-dosen-15-prozent-ohne-sticker-banane-min_1000x.jpg?v=1759387326',
//       price: '€127,46',
//       comparePrice: '€149,95',
//       unitPrice: '€25,49 /Stück',
//       badge: '-15%',
//       id: '55830717301113',
//     },
//   },
//   '/products/vegan-protein-neutral': {
//     '3er': {
//       title: '3x Neutral - Spare 10%',
//       img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-3-dosen-10-prozent-ohne-sticker-neutral-min_1000x.jpg?v=1759386910',
//       price: '€80,97',
//       comparePrice: '€89,97',
//       unitPrice: '€26,99 /Stück',
//       badge: '-10%',
//       id: '55830678569337',
//     },
//     '5er': {
//       title: '5x Neutral - Spare 15%',
//       img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-5-dosen-15-prozent-ohne-sticker-neutral-min_1000x.jpg?v=1759387255',
//       price: '€127,46',
//       comparePrice: '€149,95',
//       unitPrice: '€25,49 /Stück',
//       badge: '-15%',
//       id: '55830679945593',
//     },
//   },
//   '/products/vegan-protein-haselnuss-600g-bio': {
//     '3er': {
//       title: '3x Haselnuss - Spare 10%',
//       img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-3-dosen-10-prozent-ohne-sticker-haselnuss-min9_1000x.jpg?v=1759387564',
//       price: '€80,97',
//       comparePrice: '€89,97',
//       unitPrice: '€26,99 /Stück',
//       badge: '-10%',
//       id: '55830699213177',
//     },
//     '5er': {
//       title: '5x Haselnuss - Spare 15%',
//       img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-5-dosen-15-prozent-ohne-sticker-haselnuss-min_1000x.jpg?v=1759387304',
//       price: '€127,46',
//       comparePrice: '€149,95',
//       unitPrice: '€25,49 /Stück',
//       badge: '-15%',
//       id: '55830708519289',
//     },
//   },
//   '/products/vegan-protein-matcha-latte-600g-bio': {
//     '3er': {
//       title: '3x Matcha-Latte - Spare 10%',
//       img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-3-dosen-10-prozent-ohne-sticker-matcha-latte-classic-min_1000x.jpg?v=1759386934',
//       price: '€80,97',
//       comparePrice: '€89,97',
//       unitPrice: '€26,99 /Stück',
//       badge: '-10%',
//       id: '55830681682297',
//     },
//     '5er': {
//       title: '5x Matcha-Latte - Spare 15%',
//       img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-5-dosen-15-prozent-ohne-sticker-matcha-latte-classic-min_1000x.jpg?v=1759387280',
//       price: '€127,46',
//       comparePrice: '€149,95',
//       unitPrice: '€25,49 /Stück',
//       badge: '-15%',
//       id: '55830688235897',
//     },
//   },
//   '/products/vegan-protein-iced-coffee-600g-bio': {
//     '3er': {
//       title: '3x Iced-Coffee - Spare 10%',
//       img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-3-dosen-10-prozent-ohne-sticker-iced-coffee-classic-min_1000x.jpg?v=1759387027',
//       price: '€80,97',
//       comparePrice: '€89,97',
//       unitPrice: '€26,99 /Stück',
//       badge: '-10%',
//       id: '55830718873977',
//     },
//     '5er': {
//       title: '5x Iced-Coffee - Spare 15%',
//       img: 'https://vetain.de/cdn/shop/files/0924-sparbundle-5-dosen-15-prozent-ohne-sticker-iced-coffee-classic-min_1000x.jpg?v=1759387353',
//       price: '€127,46',
//       comparePrice: '€149,95',
//       unitPrice: '€25,49 /Stück',
//       badge: '-15%',
//       id: '55830724804985',
//     },
//   },
// };

// document.body.classList.add('as-ve-0031');

// waitForElement('.ve-0014-upsell-list', (upsells) => {
//   const path = window.location.pathname.replace(/\/collections\/[^\/]*/, '');
//   const data = dataMap[path];

//   if (data === undefined) {
//     return;
//   }

//   const title = upsells.parentElement.querySelector('h2');
//   title.innerHTML = 'Mehr kaufen, weniger zahlen:';

//   const newUpsellsHTML = `
//     <div class="ve-0031-upsell-list">
//       <div class="ve-0031-item" data-id="${data['3er'].id}">
//         <p class="ve-0031-item-badge">${data['3er'].badge}</p>
//         <img src="${data['3er'].img}">
//         <h3>${data['3er'].title}</h3>
//         <p class="ve-0031-item-price">${data['3er'].price}<span>${data['3er'].comparePrice}</span></p>
//         <p class="ve-0031-item-unit">${data['3er'].unitPrice}</p>
//         <div>
//           <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//             <path d="M7.99999 0.800049V15.2M0.799988 8.00005H15.2" stroke="white" stroke-width="2"></path>
//           </svg>
//         </div>
//       </div>
//       <div class="ve-0031-item" data-id="${data['5er'].id}">
//         <p class="ve-0031-item-badge">${data['5er'].badge}</p>
//         <img src="${data['5er'].img}">
//         <h3>${data['5er'].title}</h3>
//         <p class="ve-0031-item-price">${data['5er'].price}<span>${data['5er'].comparePrice}</span></p>
//         <p class="ve-0031-item-unit">${data['5er'].unitPrice}</p>
//         <div>
//           <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//             <path d="M7.99999 0.800049V15.2M0.799988 8.00005H15.2" stroke="white" stroke-width="2"></path>
//           </svg>
//         </div>
//       </div>
//     </div>
//   `;

//   upsells.insertAdjacentHTML('beforebegin', newUpsellsHTML);

//   const items = document.querySelectorAll('.ve-0031-item');
//   items.forEach((item) => {
//     const id = item.dataset.id;
//     const btn = item.querySelector('div:has(> svg)');

//     btn.addEventListener('click', () => {
//       const originalProductIDElem = document.querySelector('.product-form__buy-buttons input[name="id"]');
//       const originalProductID = parseInt(originalProductIDElem.getAttribute('value'));

//       const originalQuantityElem = document.querySelector('.quantity-selector__input');
//       const originalQuantity = originalQuantityElem.value;

//       fetch('/cart.js', {
//         method: 'GET',
//       })
//         .then((response) => {
//           return response.json();
//         })
//         .then((data) => {
//           let toRemoveQt = originalQuantity;

//           const products = data.items.filter((elem) => {
//             return elem.id === originalProductID && elem.selling_plan_allocation === undefined;
//           });

//           const set = data.items.find((elem) => {
//             return elem.id === parseInt(id);
//           });

//           const updates = {};

//           products.forEach((product) => {
//             if (toRemoveQt <= 0) {
//               return;
//             }

//             let newQt = 0;
//             if (toRemoveQt < product.quantity) {
//               newQt = product.quantity - toRemoveQt;
//             }

//             toRemoveQt -= product.quantity;

//             updates[product.key] = newQt;
//           });

//           if (set !== undefined) {
//             updates[id] = set.quantity + 1;
//           } else {
//             updates[id] = 1;
//           }

//           const closeBtn = document.querySelector('.ve-0014-footer-cart');

//           setTimeout(() => {
//             closeBtn.classList.add('ve-0031-ignore');
//             closeBtn.click();
//             closeBtn.classList.remove('ve-0031-ignore');
//           }, 1000);

//           fetch('/cart/update.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json',
//             },
//             body: JSON.stringify({ updates }),
//           }).then((response) => {
//             document.documentElement.dispatchEvent(
//               new CustomEvent('cart:refresh', {
//                 bubbles: true,
//               })
//             );
//           });
//         })
//         .catch((error) => {
//           console.error('Error:', error);
//         });
//     });
//   });
// });

// waitForElement('#AddToCart', (atc) => {
//   atc.addEventListener('click', () => {
//     const atcText = document.querySelector('#AddToCart .loader-button__text');
//     if (atcText.innerHTML === 'In den Warenkorb') {
//       window['ablyft'].push({
//         eventType: 'custom',
//         eventName: 've-0031-click-atc-einmalig',
//         eventValue: 0, //optional
//       });
//     } else {
//       window['ablyft'].push({
//         eventType: 'custom',
//         eventName: 've-0031-click-atc-abo',
//         eventValue: 0, //optional
//       });
//     }
//   });
// });

// waitForElement('#StickyAddToCart', (atc) => {
//   atc.addEventListener('click', () => {
//     const atcText = document.querySelector('#AddToCart .loader-button__text');
//     if (atcText.innerHTML === 'In den Warenkorb') {
//       window['ablyft'].push({
//         eventType: 'custom',
//         eventName: 've-0031-click-sticky-atc-einmalig',
//         eventValue: 0, //optional
//       });
//     } else {
//       window['ablyft'].push({
//         eventType: 'custom',
//         eventName: 've-0031-click-sticky-atc-abo',
//         eventValue: 0, //optional
//       });
//     }
//   });
// });
